<template>
  <v-dialog v-model="openModal" max-width="640">
    <v-card class="card-overflow" height="420">
      <v-row class="card-height" no-gutters>
        <v-col cols="5" class="py-0 d-flex justify-center align-center card-background">
          <img
            class="img-tip"
            width="200"
            :src="detailIndicator.length ? require(`@/assets/${cardImages[detailIndicator]}`) : require('@/assets/media_de_itens_na_cesta.png')"
          />
        </v-col>
        <v-col cols="7" class="pt-3">
          <div class="d-flex flex-column full-height">
            <div class="px-5 flex-1 full-height">
              <div class="d-flex justify-space-between">
                <h3 class="mb-0 decomposition_title sky-blue">{{ action.name }}</h3>
                <mf-button color="cinza-0" type="icon" icon="close" size="xs" @click="closeModal" />
              </div>
              <p class="text-justify light-grey" v-html="action.description" />
            </div>
            <div class="d-flex justify-end px-5 pb-3">
              <a :href="action.link" target="_blank">
                <mf-button color="marca-0-l40" text label="Saiba mais" icon="arrow_forward" icon-position="right" />
              </a>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'DecompositionDetailsActionsCard',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    detailIndicator: {
      type: String,
      default: 'AVERAGE_ITEMS_IN_BASKET',
    },
    action: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    todos: '',
  }),
  computed: {
    openModal: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    cardImages() {
      return {
        AVERAGE_ITEMS_IN_BASKET: 'media_de_itens_na_cesta.png',
        AVERAGE_PRODUCT_VALUE: 'valor_medio_dos_produtos.png',
        UNIQUE_CUSTOMERS: 'clientes_unicos.png',
        AVERAGE_CUSTOMER_SPEND: 'media_de_compras_por_cliente.png',
      }
    },
  },
  methods: {
    closeModal() {
      this.openModal = false
    },
  },
}
</script>

<style lang="scss">
.card-height {
  height: 100%;
}
.card-overflow {
  overflow-x: hidden;
}
.card-background {
  background-color: $marca-0-l40;
}
</style>
